import FormData from 'form-data'
import fetch from 'node-fetch'

import { getEndpointUrl } from '../utils/config-resolver.js'

import { STORAGE } from '@things-factory/attachment-base'
import { AthenaController } from '@things-factory/aws-base'
import { config } from '@things-factory/env'

const dataReportConfig = config.get('dataReport')
const {
  jasper: {
    endpoint: ENDPOINT,
    datasource: { database: DATABASE }
  }
} = dataReportConfig || {
  jasper: {
    endpoint: {},
    datasource: {}
  }
}

function transformValuesToRows(queryResult) {
  var parseData = []
  let index = 1
  for (let i = 0; i < queryResult.Items.length; i++) {
    var j = 0
    const data = JSON.parse(queryResult.Items[i].data)
    const spec = JSON.parse(queryResult.Items[i].spec)

    for (let key in data) {
      if (Array.isArray(data[key])) {
        for (j = 0; j < data[key].length; j++) {
          for (let specKey in spec) {
            if (key === specKey) {
              parseData.push({
                item: spec[specKey].name,
                index: index + j,
                value: String(data[key][j])
              })
            }
          }
        }
      } else {
        parseData.push({
          item: key,
          index,
          value: String(data[key])
        })
      }
    }
    if (j !== 0) {
      index = index + j
    } else {
      index = index + 1
    }
  }
}

/** @todo considering trasformation in lambda, as massive dataset */
function pivotData(rows) {
  let parsedData = []
  let index = 1
  for (let i = 0; i < rows.length; i++) {
    let j = 0
    const data = JSON.parse(rows[i].data)
    const spec = JSON.parse(rows[i].spec)

    for (let key in data) {
      /** @todo rule to display or not, about unspecified spec */
      const value = data[key]
      !spec[key]?.hidden &&
        parsedData.push({
          item: spec[key]?.name || key,
          index,
          value: Array.isArray(value) ? value.join(', ') : value
        })
    }
    if (j !== 0) {
      index = index + j
    } else {
      index = index + 1
    }
  }

  return parsedData
}

function parseJsonDataField(rows) {
  let parsedData = []
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i]
    const data = JSON.parse(row.data)
    for (let key in data) {
      if (Array.isArray(data[key])) {
        data[key] = data[key].toString()
      }
    }
    delete row.data
    parsedData.push({ ...row, ...data })
  }

  return parsedData
}

const athenaClient = new AthenaController()

async function queryAthena(params) {
  const { table, domain, datasetId, startDate, endDate, workShift, timezone } = params
  const queryData = {
    sql: `SELECT ds.name, ds.description, ds.data, dsh.data_items as spec, ds.workdate, ds.workshift,
    DATE_FORMAT(
      FROM_UNIXTIME(collected_at / 1000 / 1000) AT TIME ZONE '${timezone || 'UTC'}', 
      '%Y-%m-%d %H:%i:%s'
    ) AS dscollected_at
    FROM ${table} ds
    JOIN data_set_histories dsh 
      ON (ds.datasetid = dsh.original_id
        and ds.data_set_version = dsh.version)
    WHERE ds.domain='${domain}' 
    AND ds.datasetid = '${datasetId}'
    AND ds.workdate >= '${startDate}'
    AND ds.workdate <= '${endDate}'
    ${workShift ? "AND ds.workshift = '" + workShift + "'" : ''}
    ORDER BY ds.collected_at`,
    db: DATABASE
  }
  // and json_extract_scalar(data, '$.dauid') = 'A8032AD81730'

  return await athenaClient.query(queryData)
}

export async function renderJasperReport(context: any) {
  const {
    state: { domain },
    query
  } = context

  const template = await STORAGE.readFile(query['reportTemplate'] || 'dynamic_header_sample.jrxml', 'utf-8')
  let templateType = query['templateType'] || 'crosstab'
  let parsedData = []

  // @todo: get dataset timezone
  /**
   * const variables = await gql(dataSet(id:${dataSetId}) {
   *  name, description, partition_keys, timezone
   * })
   */

  query['domain'] = domain?.subdomain
  query['timezone'] = domain?.timezone
  const queryResult = await queryAthena(query)
  const rows = queryResult.Items

  if (!rows.length) {
    return '<h3>Not found result.</h3>'
  } else {
    const firstRow = rows[0]
    // uses the first row values as data-set has no history data.
    const parameters = {
      name: firstRow.name,
      description: firstRow.description,
      ...query
    }

    if (templateType === 'crosstab') {
      parsedData = pivotData(rows)
    } else {
      parsedData = parseJsonDataField(rows)
    }

    const formData = new FormData()
    formData.append('template', template)
    formData.append('jsonString', JSON.stringify(parsedData))
    formData.append('parameters', JSON.stringify(parameters))

    const { reportView } = query
    const url = getEndpointUrl(ENDPOINT, reportView)
    const response = await fetch(url, {
      method: 'POST',
      body: formData
    })

    return await response.text()
  }
}
